import script from "./uploadImg.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadImg.vue?vue&type=script&setup=true&lang=js"

import "./uploadImg.vue?vue&type=style&index=0&id=6222058d&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod_web_mall_haier_mall/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6222058d"]])

export default __exports__